import { BALANCE_HEALTH_WORKERS_COMP_POLICY } from "@/configuration/groups/balance-health/workers-comp";
import { getGroupConfigSubdomain } from "@/configuration/paths";
import { ConfigSubdomain } from "@/configuration/tenant-ids";
import type { Group } from "@/src/models/group";
import type { WorkersCompReferralPolicy } from "@/src/models/workers-comp-referral";

/** Null when the group does not treat comp referrals specially. Not in the `configuration/index.ts`
 * barrel: client components gate on this, and that barrel reads tenant YAML from disk. */
export function getWorkersCompReferralPolicy(group: Group): WorkersCompReferralPolicy | null {
  switch (getGroupConfigSubdomain(group)) {
    case ConfigSubdomain.BALANCE_HEALTH:
      return BALANCE_HEALTH_WORKERS_COMP_POLICY;
    default:
      return null;
  }
}
